export default __webpack_public_path__ + "static/media/ngoRed.9bfba2d7.svg";